import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';

export const links = [
  {
    id: 'link-1',
    name: 'Home',
    path: 'hero',
    offset: 0,
  },
  {
    id: 'link-2',
    name: 'Skills',
    path: 'skills',
    offset: -100,
  },
  {
    id: 'link-3',
    name: 'Experience',
    path: 'experience',
    offset: -50,
  },
  {
    id: 'link-4',
    name: 'Projects',
    path: 'projects',
    offset: -100,
  },
  {
    id: 'link-5',
    name: 'Testimonials',
    path: 'testimonials',
    offset: -80,
  },
];

const NavigationLink = ({ name, path, offset, setIsOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <li>
      <ScrollLink
        to={path}
        spy
        smooth
        duration={500}
        activeClass={`${location.pathname === '/' ? 'text-primaryBlack dark:text-primaryBlue' : ''}`}
        className="cursor-pointer hover:text-primaryBlack dark:hover:text-primaryBlue"
        onClick={() => {
          if (setIsOpen) {
            setIsOpen(false);
          }
          navigate(`/#${path}`);
        }}
        offset={offset}
      >
        {name}
      </ScrollLink>
    </li>
  );
};

export default NavigationLink;
